"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Column", {
  enumerable: true,
  get: function get() {
    return _Column.default;
  }
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Column = _interopRequireDefault(require("./Column"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var TwoColumnsLayout = function TwoColumnsLayout(props) {
  var left = props.left,
      right = props.right;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "two-columns-layout"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "two-columns-layout__left"
  }, left), /*#__PURE__*/_react.default.createElement("div", {
    className: "two-columns-layout__spacer"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "two-columns-layout__right"
  }, right));
};

TwoColumnsLayout.propTypes = {
  left: _propTypes.default.node.isRequired,
  right: _propTypes.default.node.isRequired
};
var defaultProps = {
  left: null,
  right: null
};
TwoColumnsLayout.defaultProps = defaultProps;
var _default = TwoColumnsLayout;
exports.default = _default;